import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { useDynamicMenu } from 'hooks/useDynamicMenu';
import { DASHBOARD_PATH } from 'config';
import { GuardProps } from 'types';
import { resolveUserRole } from 'utils/resolveUserRole';
import { FORM_ROLE } from 'utils/createFormRolePolicy';
import { findFirstMenuUrl } from 'utils/menuTransformer';
import { useEffect } from 'react';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn, user } = useAuth();
  const isManager = resolveUserRole(user) === FORM_ROLE.MANAGER;
  // Manager has no dashboard — only needed while resolving their landing page below.
  const { menuItems, isLoading: isMenuLoading } = useDynamicMenu();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) return;
    if (isManager) {
      if (isMenuLoading) return; // wait for the menu so we know where to land
      navigate(findFirstMenuUrl(menuItems) ?? DASHBOARD_PATH, { replace: true });
      return;
    }
    navigate(DASHBOARD_PATH, { replace: true });
  }, [isLoggedIn, isManager, isMenuLoading, menuItems, navigate]);

  return children;
}
